<template>
  <Compliance v-if="displayCompliancePage" />
  <EldConnections v-else />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import EldConnections from '@/views/carrier/ELDConnections.vue';
import Compliance from '@/views/carrier/Compliance.vue';

const store = useStore();

const displayCompliancePage = computed(() => {
  return store.state.users.featureFlags?.display_compliance_page?.enabled;
});
</script>
